import { MetricOption } from '@aleph/shared-components';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { VARIABLES } from 'wb-reddit/styles/variables';
import { startCase } from 'lodash';

// TODO translate and remove map function
export const chartMetrics: MetricOption[] = [
	{ value: 'impressions', label: 'impressions' },
	{ value: 'spend', label: 'spend' },
	{ value: 'clicks', label: 'clicks' },
	{ value: 'cpc', label: 'CPC (Cost per click)' },
	{ value: 'ctr', label: 'CTR (Click-through rate)' },
	{ value: 'ecpm', label: 'eCPM (Effective cost per mille)' },
	{ value: 'appInstallMetricsAddPaymentInfo', label: 'appInstallMetricsAddPaymentInfo' },
	{ value: 'appInstallMetricsAddToCart', label: 'appInstallMetricsAddToCart' },
	{ value: 'appInstallMetricsAppLaunch', label: 'appInstallMetricsAppLaunch' },
	{ value: 'appInstallMetricsCompletedTutorial', label: 'appInstallMetricsCompletedTutorial' },
	{ value: 'appInstallMetricsInstall', label: 'appInstallMetricsInstall' },
	{ value: 'appInstallMetricsLevelAchieved', label: 'appInstallMetricsLevelAchieved' },
	{ value: 'appInstallMetricsPurchase', label: 'appInstallMetricsPurchase' },
	{ value: 'appInstallMetricsSearch', label: 'appInstallMetricsSearch' },
	{ value: 'appInstallMetricsSignUp', label: 'appInstallMetricsSignUp' },
	{ value: 'appInstallMetricsSpend', label: 'appInstallMetricsSpend' },
	{ value: 'appInstallMetricsSpendCredits', label: 'appInstallMetricsSpendCredits' },
	{ value: 'appInstallMetricsViewContent', label: 'appInstallMetricsViewContent' },
	{ value: 'commentDownvotes', label: 'commentDownvotes' },
	{ value: 'commentUpvotes', label: 'commentUpvotes' },
	{ value: 'commentsPageViews', label: 'commentsPageViews' },
	{ value: 'conversionAddToCartTotalItems', label: 'conversionAddToCartTotalItems' },
	{ value: 'conversionAddToCartTotalValue', label: 'conversionAddToCartTotalValue' },
	{ value: 'conversionAddToWishlistTotalItems', label: 'conversionAddToWishlistTotalItems' },
	{ value: 'conversionAddToWishlistTotalValue', label: 'conversionAddToWishlistTotalValue' },
	{ value: 'conversionLeadTotalValue', label: 'conversionLeadTotalValue' },
	{ value: 'conversionPurchaseTotalItems', label: 'conversionPurchaseTotalItems' },
	{ value: 'conversionPurchaseTotalValue', label: 'conversionPurchaseTotalValue' },
	{ value: 'conversionSignupTotalValue', label: 'conversionSignupTotalValue' },
	{
		value: 'customClickThroughConversionsAttributionWindowDay',
		label: 'customClickThroughConversionsAttributionWindowDay',
	},
	{
		value: 'customClickThroughConversionsAttributionWindowMonth',
		label: 'customClickThroughConversionsAttributionWindowMonth',
	},
	{
		value: 'customClickThroughConversionsAttributionWindowWeek',
		label: 'customClickThroughConversionsAttributionWindowWeek',
	},
	{
		value: 'customViewThroughConversionsAttributionWindowDay',
		label: 'customViewThroughConversionsAttributionWindowDay',
	},
	{
		value: 'customViewThroughConversionsAttributionWindowMonth',
		label: 'customViewThroughConversionsAttributionWindowMonth',
	},
	{
		value: 'customViewThroughConversionsAttributionWindowWeek',
		label: 'customViewThroughConversionsAttributionWindowWeek',
	},
	{ value: 'videoFullyViewableImpressions', label: 'videoFullyViewableImpressions' },
	{ value: 'videoPlaysExpanded', label: 'videoPlaysExpanded' },
	{ value: 'videoPlaysWithSound', label: 'videoPlaysWithSound' },
	{ value: 'videoStarted', label: 'videoStarted' },
	{ value: 'videoViewableImpressions', label: 'videoViewableImpressions' },
	{ value: 'videoWatched100Percent', label: 'videoWatched100Percent' },
	{ value: 'videoWatched10Seconds', label: 'videoWatched10Seconds' },
	{ value: 'videoWatched25Percent', label: 'videoWatched25Percent' },
	{ value: 'videoWatched3Seconds', label: 'videoWatched3Seconds' },
	{ value: 'videoWatched50Percent', label: 'videoWatched50Percent' },
	{ value: 'videoWatched5Seconds', label: 'videoWatched5Seconds' },
	{ value: 'videoWatched75Percent', label: 'videoWatched75Percent' },
	{ value: 'videoWatched95Percent', label: 'videoWatched95Percent' },
	{ value: 'viewableImpressions', label: 'viewableImpressions' },
	{ value: 'viewerComments', label: 'viewerComments' },
].map(metric => ({ ...metric, label: startCase(metric.label), type: 'area' }));

export const breakdownChartMetrics: string[] = [
	'impressions',
	'spend',
	'clicks',
	'appInstallMetricsAddPaymentInfo',
	'appInstallMetricsAddToCart',
	'appInstallMetricsAppLaunch',
	'appInstallMetricsCompletedTutorial',
	'appInstallMetricsInstall',
	'appInstallMetricsLevelAchieved',
	'appInstallMetricsPurchase',
	'appInstallMetricsSearch',
	'appInstallMetricsSignUp',
	'appInstallMetricsSpend',
	'appInstallMetricsSpendCredits',
	'appInstallMetricsViewContent',
	'commentDownvotes',
	'commentUpvotes',
	'commentsPageViews',
	'conversionAddToCartTotalItems',
	'conversionAddToCartTotalValue',
	'conversionAddToWishlistTotalItems',
	'conversionAddToWishlistTotalValue',
	'conversionLeadTotalValue',
	'conversionPurchaseTotalItems',
	'conversionPurchaseTotalValue',
	'conversionSignupTotalValue',
	'customClickThroughConversionsAttributionWindowDay',
	'customClickThroughConversionsAttributionWindowMonth',
	'customClickThroughConversionsAttributionWindowWeek',
	'customViewThroughConversionsAttributionWindowDay',
	'customViewThroughConversionsAttributionWindowMonth',
	'customViewThroughConversionsAttributionWindowWeek',
	'videoFullyViewableImpressions',
	'videoPlaysExpanded',
	'videoPlaysWithSound',
	'videoStarted',
	'videoViewableImpressions',
	'videoWatched100Percent',
	'videoWatched10Seconds',
	'videoWatched25Percent',
	'videoWatched3Seconds',
	'videoWatched50Percent',
	'videoWatched5Seconds',
	'videoWatched75Percent',
	'videoWatched95Percent',
	'viewableImpressions',
	'viewerComments',
	'cpc',
	'ctr',
	'ecpm',
];

// TODO translate
export const kpiOptions = [
	{ value: 'impressions', label: '' },
	{ value: 'spend', label: '' },
	{ value: 'clicks', label: '' },
	{ value: 'appInstallMetricsAddPaymentInfo', label: 'App Install - Add Payment Info' },
	{ value: 'appInstallMetricsAddToCart', label: 'App Install - Add To Cart' },
	{ value: 'appInstallMetricsAppLaunch', label: 'App Install - App Launch' },
	{ value: 'appInstallMetricsCompletedTutorial', label: 'App Install - Completed Tutorial' },
	{ value: 'appInstallMetricsInstall', label: 'App Install - Install' },
	{ value: 'appInstallMetricsLevelAchieved', label: 'App Install - Level Achieved' },
	{ value: 'appInstallMetricsPurchase', label: 'App Install - Purchase' },
	{ value: 'appInstallMetricsSearch', label: 'App Install - Search' },
	{ value: 'appInstallMetricsSignUp', label: 'App Install - Sign Up' },
	{ value: 'appInstallMetricsSpend', label: 'App Install - Spend' },
	{ value: 'appInstallMetricsSpendCredits', label: 'App Install - Spend Credits' },
	{ value: 'appInstallMetricsViewContent', label: 'App Install - View Content' },
	{ value: 'commentDownvotes', label: '' },
	{ value: 'commentUpvotes', label: '' },
	{ value: 'commentsPageViews', label: '' },
	{ value: 'conversionAddToCartTotalItems', label: '' },
	{ value: 'conversionAddToCartTotalValue', label: '' },
	{ value: 'conversionAddToWishlistTotalItems', label: '' },
	{ value: 'conversionAddToWishlistTotalValue', label: '' },
	{ value: 'conversionLeadTotalValue', label: '' },
	{ value: 'conversionPurchaseTotalItems', label: '' },
	{ value: 'conversionPurchaseTotalValue', label: '' },
	{ value: 'conversionSignupTotalValue', label: '' },
	{ value: 'customClickThroughConversionsAttributionWindowDay', label: '' },
	{ value: 'customClickThroughConversionsAttributionWindowMonth', label: '' },
	{ value: 'customClickThroughConversionsAttributionWindowWeek', label: '' },
	{ value: 'customViewThroughConversionsAttributionWindowDay', label: '' },
	{ value: 'customViewThroughConversionsAttributionWindowMonth', label: '' },
	{ value: 'customViewThroughConversionsAttributionWindowWeek', label: '' },
	{ value: 'videoFullyViewableImpressions', label: '' },
	{ value: 'videoPlaysExpanded', label: '' },
	{ value: 'videoPlaysWithSound', label: '' },
	{ value: 'videoStarted', label: '' },
	{ value: 'videoViewableImpressions', label: '' },
	{ value: 'videoWatched100Percent', label: '' },
	{ value: 'videoWatched10Seconds', label: '' },
	{ value: 'videoWatched25Percent', label: '' },
	{ value: 'videoWatched3Seconds', label: '' },
	{ value: 'videoWatched50Percent', label: '' },
	{ value: 'videoWatched5Seconds', label: '' },
	{ value: 'videoWatched75Percent', label: '' },
	{ value: 'videoWatched95Percent', label: '' },
	{ value: 'viewableImpressions', label: '' },
	{ value: 'viewerComments', label: '' },
	{ value: 'cpc', label: '' },
	{ value: 'ctr', label: '' },
	{ value: 'ecpm', label: '' },
];

export const PIE_LEVEL_COLORS = {
	[RedditLevel.AD_ACCOUNT]: [
		VARIABLES.COLORS.BLUE[500],
		VARIABLES.COLORS.BLUE[600],
		VARIABLES.COLORS.BLUE[700],
		VARIABLES.COLORS.BLUE[800],
		VARIABLES.COLORS.BLUE[400],
		VARIABLES.COLORS.BLUE[300],
		VARIABLES.COLORS.BLUE[200],
	],
	[RedditLevel.CAMPAIGN]: [
		VARIABLES.COLORS.VIOLET[500],
		VARIABLES.COLORS.VIOLET[600],
		VARIABLES.COLORS.VIOLET[700],
		VARIABLES.COLORS.VIOLET[800],
		VARIABLES.COLORS.VIOLET[400],
		VARIABLES.COLORS.VIOLET[300],
		VARIABLES.COLORS.VIOLET[200],
	],
	[RedditLevel.GROUP]: [
		VARIABLES.COLORS.CYAN[500],
		VARIABLES.COLORS.CYAN[600],
		VARIABLES.COLORS.CYAN[700],
		VARIABLES.COLORS.CYAN[800],
		VARIABLES.COLORS.CYAN[400],
		VARIABLES.COLORS.CYAN[300],
		VARIABLES.COLORS.CYAN[200],
	],
	[RedditLevel.AD]: [
		VARIABLES.COLORS.APPLE_GREEN[500],
		VARIABLES.COLORS.APPLE_GREEN[600],
		VARIABLES.COLORS.APPLE_GREEN[700],
		VARIABLES.COLORS.APPLE_GREEN[800],
		VARIABLES.COLORS.APPLE_GREEN[400],
		VARIABLES.COLORS.APPLE_GREEN[300],
		VARIABLES.COLORS.APPLE_GREEN[200],
	],
};

export const LEVEL_COLORS = {
	[RedditLevel.AD_ACCOUNT]: [
		VARIABLES.COLORS.BLUE[500],
		VARIABLES.COLORS.GRAY[700],
		VARIABLES.COLORS.TURQUOISE[600],
		VARIABLES.COLORS.PURPLE[500],
		VARIABLES.COLORS.YELLOW[500],
		VARIABLES.COLORS.GRAY[900],
	],
	[RedditLevel.CAMPAIGN]: [
		VARIABLES.COLORS.VIOLET[500],
		VARIABLES.COLORS.GRAY[700],
		VARIABLES.COLORS.ROSE[500],
		VARIABLES.COLORS.TURQUOISE[600],
		VARIABLES.COLORS.YELLOW[500],
		VARIABLES.COLORS.GRAY[900],
	],
	[RedditLevel.GROUP]: [
		VARIABLES.COLORS.CYAN[600],
		VARIABLES.COLORS.GRAY[700],
		VARIABLES.COLORS.ROSE[500],
		VARIABLES.COLORS.YELLOW[500],
		VARIABLES.COLORS.TURQUOISE[700],
		VARIABLES.COLORS.GRAY[900],
	],
	[RedditLevel.AD]: [
		VARIABLES.COLORS.APPLE_GREEN[600],
		VARIABLES.COLORS.GRAY[700],
		VARIABLES.COLORS.ROSE[500],
		VARIABLES.COLORS.TURQUOISE[700],
		VARIABLES.COLORS.YELLOW[500],
		VARIABLES.COLORS.GRAY[900],
	],
};

export const getChartColor = ({ idx = 0, level, count }:
{ idx?: number | undefined, level?: RedditLevel, faded?: boolean, count?: number }, pieChart?: boolean) => {
	if (!level) {
		return VARIABLES.COLORS.GRAY[700];
	}

	return !pieChart
		? LEVEL_COLORS?.[level]?.[(idx) % 6]
		: count && count === 1
			? PIE_LEVEL_COLORS?.[level]?.[3]
			: PIE_LEVEL_COLORS?.[level]?.[(idx) % 7];
};
